import { Entity } from '@/interfaces'
import model from './model'
import repository from './repository'

const travelPricingAgeGroupEntity: Entity = {
  model: model,
  repository: repository,
}

export default travelPricingAgeGroupEntity
